export default __webpack_public_path__ + "static/media/Portadas-Blog-GAMA-1-3-768x576.4a3f8db8.webp";